export default "__VITE_ASSET__DzPT7Hp3__"